import { useState } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'

import { getRarityPoints, getUnusableAmount } from 'src/lib/item'
import BtnPlus from 'src/assets/img/common/btn_plus_pink.svg'
import BtnMinus from 'src/assets/img/common/btn_minus_pink.svg'

import ModalCommon from 'src/components/common/ModalCommon'

const ModalItemDetail = ({ item, handleClose, open, handleConfirmAmount, currentAmount }) => {
  const countItemAvailable = item.amount - getUnusableAmount(item)
  const [countItem, setCountItem] = useState(currentAmount)
  const handleCountPlusItem = () => {
    setCountItem(countItem + 1)
  }
  const handleCountMinusItem = () => {
    setCountItem(countItem - 1)
  }

  const modalButtons = [
    {
      label: 'キャンセル',
      onClick: () => {
        handleClose()
      },
      type: 'close'
    },
    {
      label: 'OK',
      onClick: () => {
        if (countItem < 0) return
        handleConfirmAmount(item, countItem)
        handleClose()
      }
    }
  ]

  return (
    <ModalCommon title=" " open={open} onClose={handleClose} buttons={modalButtons} theme="pink">
      <div className="bg-[#FFFFFF] mt-5 text-center relative overflow-auto h-[350px] hidden-scroll">
        <h1 className="mt-4 mb-2 font-Inter text-candy-pink font-bold text-lg">
          アイテムを何個使いますか？
        </h1>
        <div>
          <div className="flex gap-5 items-center justify-center">
            <button onClick={handleCountMinusItem} disabled={countItem < 1}>
              <img
                className={`w-[30px] ${countItem < 1 ? 'filter grayscale' : ''}`}
                src={BtnMinus}
              />
            </button>
            <ItemThumbnail
              image={item.icon_url}
              imgClassName="w-[120px] h-[120px] object-cover"
              className=""
              rarity
            />
            <div>
              <button disabled={countItemAvailable === countItem} onClick={handleCountPlusItem}>
                <img
                  className={`${countItemAvailable === countItem ? 'filter grayscale' : ''} w-[30px]`}
                  src={BtnPlus}
                />
              </button>
            </div>
          </div>
          <div className="text-center my-2 font-Inter text-candy-pink font-semibold">
            使用するアイテム ×<span className="text-[#484848] text-xl ml-2">{countItem}</span>
          </div>
          <button
            className="bg-candy-pink w-[136px] p-1 rounded-[7px] text-white font-bold"
            onClick={() => setCountItem(countItemAvailable)}
          >
            全て使う
          </button>
          <p className="w-[136px] m-auto justify-center font-bold bg-[#F7F7F7] font-Inter text-sm p-[5px] rounded-[7px] text-center mt-2 text-candy-pink">
            所持アイテム数
            <span className="text-[#484848] ml-2">{countItemAvailable}</span>
          </p>
          <p className="w-44 m-auto justify-center font-bold bg-[#F7F7F7] font-Inter text-sm p-[5px] rounded-[7px] text-center mt-4 text-candy-pink">
            獲得ポイント
            <span className="ml-6 text-candy-pink text-xs font-ShinMaruGo">
              +{getRarityPoints(item.rarity) * countItem}
            </span>
          </p>
        </div>
      </div>
    </ModalCommon>
  )
}

ModalItemDetail.propTypes = {
  item: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  handleConfirmAmount: PropTypes.func.isRequired,
  currentAmount: PropTypes.number
}

const ItemThumbnail = ({
  image,
  rarity,
  className = 'w-[72px] h-[80px] border-menu-dark-blue rounded-sm',
  imgClassName = 'w-[60px]'
}) => {
  return (
    <div
      className={clsx(
        'flex justify-center items-center relative',
        className,
        !rarity && 'border-2 drop-shadow-md bg-white'
      )}
    >
      <img className={clsx(imgClassName)} src={image} />
    </div>
  )
}

ItemThumbnail.propTypes = {
  image: PropTypes.string.isRequired,
  rarity: PropTypes.bool,
  loveAmount: PropTypes.number,
  className: PropTypes.string,
  imgClassName: PropTypes.string
}

const ValueIndicator = ({ label, value, bgStyle, marginRight }) => {
  return (
    <div
      className={`rounded border h-8 flex text-xs font-hiragino bg-[#DAEBFF] w-[150px] ${marginRight} mb-1`}
    >
      <span className=" w-full flex items-center justify-center h-full align-middle px-2 text-center">
        {label}
      </span>
    </div>
  )
}

ValueIndicator.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  marginRight: PropTypes.string.isRequired,
  bgStyle: PropTypes.string.isRequired
}

export default ModalItemDetail
